import request from 'axios'
import qs from 'qs'

request.defaults.baseURL = window.url
request.defaults.withCredentials=true;
if (window.location.hostname == 'ourwork-admin.duiyou360.com') {
    // 正式服
    request.defaults.baseURL = 'https://ourwork-admin-api.duiyou360.com';    
} else {
    // 测试服      
    // request.defaults.baseURL = 'http://ourwork-admin-api.t.duiyou360.com';
    request.defaults.baseURL = 'https://ourwork-admin-api.t.yingshouda.com/'; 
    // request.defaults.baseURL = 'http://192.168.0.8:8081'; 
    // request.defaults.baseURL = 'http://localhost:7071'; //ling
    // request.defaults.baseURL = 'http://192.168.101.101:8081'; //hyq

}

import App from '../main'

let map = {
    401: '已被审核，请不要重复审核'
}

request.interceptors.request.use(function(config) {

    const auth = localStorage.getItem('neworkadmintoken')
    const contentType = config.headers['Content-Type'];
    if (auth) {
        config.params = config.params || {}
        config.params.JSESSIONID = auth
    }

    if (config.method == 'post' && contentType != 'application/json') {
        config.data = qs.stringify(config.data)
    }
    
    return config;
}, function(error) {

    App.$message.error(error)

});

request.interceptors.response.use(function(res) {

    if (res.headers.token && res.headers.token === 'timeout') {
        localStorage.removeItem('username')
        localStorage.removeItem('neworkadmintoken')
        localStorage.removeItem('menuList')
        location.href = '/login'

    }
    let { code, desc, data } = res.data;
    if ( res.headers["content-type"].match(/application\/json/) && code !== 200) {
        App.$message.error(map[code] || desc || data)
    }
    return res
})

export default request



// WEBPACK FOOTER //
// ./src/views/request.js